import { FunctionComponent } from 'react'
import { useHistory } from 'react-router-dom'
import {
  Container,
  Header,
  Main,
  Typography,
  Button,
  Action,
  Heading,
} from './styles'

const Encerramento: FunctionComponent = () => {
  const history = useHistory()
  return (
    <Container>
      <Header />
      <Main>
        <Heading variant="h4">Cadastro efetuado com sucesso!</Heading>
        <Typography variant="p1" fontWeight="semibold">
          <b>ATENÇÃO:</b> Caso não tenha recebido confirmação de cadastro,
          verifique sua caixa de spam.
        </Typography>
      </Main>
      <Action>
        <Button
          type="submit"
          variant="contained"
          size="lg"
          onClick={() => history.push('/')}
        >
          Concluir
        </Button>
      </Action>
    </Container>
  )
}

export default Encerramento
